/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Mfa_Page_Description_SelectInputs */

const de_auth_mfa_page_description_select = /** @type {(inputs: Auth_Mfa_Page_Description_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir müssen erst sichergehen, dass Sie es sind, bevor Sie Ihre E-Mail ändern können.`)
};

/** @type {(inputs: Auth_Mfa_Page_Description_SelectInputs) => LocalizedString} */
const en_auth_mfa_page_description_select = de_auth_mfa_page_description_select;

/**

* @param {Auth_Mfa_Page_Description_SelectInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_mfa_page_description_select = /** @type {((inputs?: Auth_Mfa_Page_Description_SelectInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Mfa_Page_Description_SelectInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_auth_mfa_page_description_select(inputs)
	return en_auth_mfa_page_description_select(inputs)
});